<template>
  <div class="col-sm-12 col-md">
    <b-form-group>
      <template #label>
        <span>
          {{ computedLabel }}<span v-if="required" class="text-danger"> *</span>
        </span>
      </template>
      <b-form-file
        id="input-company-id-documents"
        v-model="model"
        :state="errors ? false : null"
        :placeholder="computedPlaceholder"
        @change="inputChange"
        @input="onInput"
        :required="isFileSelectionRequired"
        :browse-text="$t('Browse')"
        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
        multiple
        :disabled="disabled"
      />
      <div v-if="errors" class="invalid-feedback d-block">
        {{ errors }}
      </div>
      <UploadedFilesList 
        :files="existingFiles" 
        :deleted-files="deletedFiles"
        @remove="onRemoveExistingFile"
        @mark-for-deletion="onMarkFileForDeletion"
        @restore="onRestoreFile"
      />
    </b-form-group>
  </div>
</template>

<script>
import BaseInputMixin from "../../../../mixins/profileInputMixin";
import {mapState} from "vuex";
import UploadedFilesList from "./UploadedFilesList.vue";
import identificationFilesMixin from "../../../../mixins/identificationFilesMixin";

export default {
  name: "CompanyIdDocuments",
  mixins: [BaseInputMixin('company_id_documents', 'identityVerification', 'identityVerificationFieldOnInput'), identificationFilesMixin('company_id_documents')],
  components: { UploadedFilesList },
  data() {
    return {
      defaultLabel: this.$t("Company ID Documents"),
      defaultPlaceholder: this.$t("Choose files...")
    }
  },
  computed: {
    ...mapState({})
  }
}
</script>

<style scoped>

</style>
